module.exports = __webpack_public_path__ + "img/toilet-paper-under-slash.c6f5d48d.svg";